import './alachelle/style';
import FormStructure from './alachelle/form_structure';

export default FormStructure;